const segment = {

	elem: {
		character: document.querySelectorAll('.segment-character'),
		words: document.querySelectorAll('.segment-word')
	},

	init() {
		// split all characters in an element into individual spans, and add an aria-label on the parent element
		if(segment.elem.character.length > 0) {
			segment.elem.character.forEach(function(element) {
				let text = element.innerHTML;
				let span = text.replace(/\S/g, '<span>$&</span>');
				element.setAttribute('aria-label', text);
				element.innerHTML = span;
			});
		}

		// split all words in an element into individual spans, and add an aria-label on the parent element		
		if(segment.elem.words.length > 0) {
			segment.elem.words.forEach(function(element) {
				let text = element.innerHTML;
				let span = text.replace(/\S+/g, '<span>$&</span>');
				element.setAttribute('aria-label', text);				
				element.innerHTML = span;
			});
		}
	}
};

export { segment };
